"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * RTL 2021 API (2026.08.10.)
 * RTL 2021 API (2026.08.10.)
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: rtlteam@konzorcia.hu
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.CastingFormListDataFromJSON = CastingFormListDataFromJSON;
exports.CastingFormListDataFromJSONTyped = CastingFormListDataFromJSONTyped;
exports.CastingFormListDataToJSON = CastingFormListDataToJSON;
exports.CastingFormListDataToJSONTyped = CastingFormListDataToJSONTyped;
const _1 = require("./");
function CastingFormListDataFromJSON(json) {
    return CastingFormListDataFromJSONTyped(json, false);
}
function CastingFormListDataFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'items': (json['items'].map(_1.CastingFormListDataFieldsFromJSON)),
        'totalCount': json['totalCount'],
    };
}
function CastingFormListDataToJSON(value) {
    return CastingFormListDataToJSONTyped(value, false);
}
function CastingFormListDataToJSONTyped(value, ignoreDiscriminator = false) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'items': (value.items.map(_1.CastingFormListDataFieldsToJSON)),
        'totalCount': value.totalCount,
    };
}
